(function () {
    "use strict";

    Components.ZoomRedirect = {
        controller: "ZoomRedirectController",
        name: "hbZoomRedirect",
        templateUrl:
            "angular/app/modules/core/features/zoom_integration/zoom_redirect_page_template.html",
    };
})();
